import { AgcGeoRoles, UserDetails } from '@/types/shared';
import { DomainCode } from '@australiangreens/ag-internal-components';
import { User } from '@auth0/auth0-react';
import logger from '@/util/logger';
import callBackendApi from './call';

export const getUserDetails = async (token: string, abortSignal?: AbortSignal) => {
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: '/currentuserinfo',
    abortSignal,
  });

  logger.debug('getUserDetails() result', data);

  return data as UserDetails;
};

export const putUserDetails = async (token: string, user: User, abortSignal?: AbortSignal) => {
  await callBackendApi({
    token,
    method: 'put',
    endpoint: `/users/${user.sub}`,
    abortSignal: abortSignal,
    data: { picture: user.picture },
  });
};

export const getAgcGeoRoles = async (
  token: string,
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/currentuserinfo/agcgeoroles?domainCode=${domainCode}`,
    abortSignal,
  });

  logger.debug('getAgcGeoRoles() result', data);

  return data as AgcGeoRoles[];
};
